import { Pipe, PipeTransform } from '@angular/core';

/** Filters an array of objects so that the same field value in `object.propertyKey` cannot occur twice
 * @example
 * [{ name: 'foo' }, { name: 'foo' }, { name: 'bar' }]
 * | distinctBy:'name'
 * [{ name: 'foo' }, { name: 'bar' }]
 * */
@Pipe({
  name: 'distinctBy',
  standalone: true
})
export class DistinctByPipe implements PipeTransform {
  transform<T extends Record<string, unknown>, Key extends keyof T>(objects: T[], propertyKey: Key): T[] {
    return [...objects]
      .sort((a, b) => a[propertyKey].toString().localeCompare(b[propertyKey].toString()))
      .filter(
        (object, index, sortedObjects) => index === 0 || sortedObjects[index - 1][propertyKey] !== object[propertyKey]
      );
  }
}
